import React, { useEffect } from "react";

const Buttons = ({
  inputHandler,
  clearAll,
  clearEntry,
  changePlusMinus,
  calculateAns,
  memoryAdd,
  memoryRecall,
  memoryClear,
  transferDisplay,
  backspace,
  answer,
}) => {
  useEffect(() => {
    const handler = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const eq = document.getElementById("equalbtn");
        if (eq && typeof eq.click === 'function') eq.click();
      } else if (event.key === 'Backspace') {
        event.preventDefault();
        if (typeof backspace === 'function') backspace();
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [backspace]);

  return (
    <>
      <div className="show-btn mb-0">
        {/* Row 1: Memory + parens */}
        <button className="btn mem px-0 pt-1" onClick={memoryRecall}>MR</button>
        <button className="btn mem px-0 pt-1" onClick={memoryClear}>MC</button>
        <button className="btn mem px-0 pt-1" onClick={memoryAdd}>M+</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>(</button>
        <button className="btn exp soft px-0 pt-1" onClick={inputHandler}>)</button>

        {/* Row 2 */}
        <button className="btn num px-0 pt-1" onClick={inputHandler}>7</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>8</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>9</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>÷</button>
        <button className="btn warn px-0 pt-1" onClick={clearAll}>C</button>

        {/* Row 3 */}
        <button className="btn num px-0 pt-1" onClick={inputHandler}>4</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>5</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>6</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>x</button>
        <button className="btn warn px-0 pt-1" onClick={clearEntry}>CE</button>

        {/* Row 4 */}
        <button className="btn num px-0 pt-1" onClick={inputHandler}>1</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>2</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>3</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>-</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>√</button>

        {/* Row 5 */}
        <button className="btn exp px-0 pt-1" onClick={changePlusMinus}>±</button>
        <button className="btn num px-0 pt-1" onClick={inputHandler}>0</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>.</button>
        <button className="btn exp px-0 pt-1" onClick={inputHandler}>+</button>
        <button className="btn exp equal px-0 pt-1" id="equalbtn" onClick={calculateAns}>=</button>
      </div>

      <div className="transfer mt-0">
        <button className="btn transfer-btn mt-0 p-1" onClick={transferDisplay}>
          Transfer Display
        </button>
      </div>
    </>
  );
};

export default Buttons;
